import SectionHeading from '../shared/SectionHeading'
import styles from './styles.module.scss'

const CONDITIONS: [string, string, string][] = [
  [
    'condition_station_icon.svg',
    '駅・観光施設から徒歩5分以内',
    '6分以上の店舗は対象外となります。',
  ],
  [
    'condition_clock_icon.svg',
    '営業時間 11:00〜18:00 をカバー',
    'この時間帯をカバーしない場合は対象外となります。',
  ],
  [
    'condition_person_icon.svg',
    '営業時間中はスタッフが常駐',
    '昼休憩等による中抜けがない事、不定期営業ではない事。',
  ],
  [
    'condition_calendar_icon.svg',
    '土日祝も営業している',
    '土日祝休み・不定休店舗は対象外となります。',
  ],
  [
    'condition_store_icon.svg',
    '路面・テナント店舗',
    'マンション内店舗・住宅兼事務所は対象外となります。',
  ],
  [
    'condition_luggage_icon.svg',
    '空きスペースがある',
    '一畳（約1.82㎡）ほどのスペースが必要です。',
  ],
]

const ConditionsSection = (): JSX.Element => (
  <section className={`${styles.block} ${styles.conditions}`} id="cond">
    <div className={`${styles.content} ${styles.center}`}>
      <SectionHeading
        eyebrow="導入条件"
        title="紹介できるのは、こんな店舗・施設です"
        description="下記の条件を満たす店舗・施設が、ecbo cloak 導入の対象です。紹介前のチェックにご活用ください。"
      />
      <div className={styles.conditionGrid}>
        {CONDITIONS.map(([icon, title, description]) => (
          <div className={`${styles.conditionCard} ${styles.reveal}`} data-reveal="" key={title}>
            <span>
              <img src={`/partner-introduction/${icon}`} alt="" />
            </span>
            <div>
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
          </div>
        ))}
      </div>
      <p className={`${styles.conditionNote} ${styles.reveal}`} data-reveal="">
        <b>※ 対象外となる店舗・施設</b>
        特殊風俗のあっせん・異性の接待がある店舗、射幸性が高い遊技を提供する店舗、新興宗教関連施設、相席業態またはそれに類する店舗、反社会的勢力等に該当する場合は対象外です。
      </p>
      <p className={`${styles.conditionNote} ${styles.reveal}`} data-reveal="">
        <b>※ 導入審査について</b>
        最終的な導入可否は、ecboによる審査のうえ判断いたします。なお、審査の基準および審査結果の理由につきましては、お答えいたしかねますのであらかじめご了承ください。
      </p>
    </div>
  </section>
)

export default ConditionsSection
